export const VAR_SERVICE_AS_PROCEDURE = '#{servicoComoProcedimento}';
export const VAR_CUSTOMER_NAME = '#{cliente}';
export const VAR_SERVICE_NAME = '#{servico}';
export const VAR_DATE_AND_START_TIME = '#{data_horario}';

export const ALL_APPOINTMENT_VARS = [VAR_CUSTOMER_NAME, VAR_SERVICE_NAME, VAR_DATE_AND_START_TIME];
